import React from 'react';
import { Camera, Heart, Mountain } from 'lucide-react';
import { photographerInfo } from '../data/mock';

const About = () => {
  const interests = [
    { icon: Mountain, label: 'Landschaftsfotografie', description: 'Naturaufnahmen' },
    { icon: Camera, label: 'Porträtfotografie', description: 'Menschen & Emotionen' },
    { icon: Heart, label: 'Sportfotografie', description: 'Action & Bewegung' }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-[#0a0a0a]">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="mb-16 text-center">
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            
          >
            Über mich
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_portfolio-dark-8/artifacts/fpkjcwk3_AB560C8C-477B-449E-A7FE-ACAF7B1BDC6F.JPG"
                alt="Fabio Matt - Fotograf aus Liechtenstein"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border-4 border-amber-500 rounded-lg -z-10" />
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-6" >
              {photographerInfo.name}
            </h3>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              {photographerInfo.bio}
            </p>
            <p className="text-gray-400 mb-8 leading-relaxed">
              Fotografie ist für mich mehr als nur ein Hobby – es ist meine Art, die Welt zu sehen und zu interpretieren. Jedes Bild erzählt eine Geschichte, und ich liebe es, diese Geschichten durch meine Kamera festzuhalten.
            </p>

            {/* Interests */}
            <div className="space-y-4">
              <h4 className="text-xl font-semibold text-white mb-4">Meine Schwerpunkte</h4>
              {interests.map((interest, index) => {
                const Icon = interest.icon;
                const sectionId = interest.label === 'Landschaftsfotografie' ? '#landscape' 
                  : interest.label === 'Porträtfotografie' ? '#portrait' 
                  : '#sports';
                
                return (
                  <a
                    key={index}
                    href={sectionId}
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.querySelector(sectionId);
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="flex items-start space-x-4 p-4 bg-gray-900/50 rounded-lg border border-gray-800 hover:border-amber-500 hover:bg-gray-900/70 transition-all cursor-pointer group"
                  >
                    <Icon className="w-6 h-6 text-amber-500 mt-1 flex-shrink-0 group-hover:scale-110 transition-transform" />
                    <div>
                      <div className="text-white font-semibold mb-1 group-hover:text-amber-400 transition-colors">{interest.label}</div>
                      <div className="text-sm text-gray-400">{interest.description}</div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;